module.exports = __webpack_public_path__ + "static/apple-touch-icon-152x152-89bb4f4754a791ad146acdfb02ce48e7.png";